import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import React from "react";

import { IPaidUserLandingProps } from "./paid-user-landing.types";
import { PaidUserLandingLaptop } from "./paid-user-laptop";
import { PaidUserMobile } from "./paid-user-mobile";

const PaidUserLanding: React.FC<IPaidUserLandingProps> = ({
  primaryUser,
  userSubscriptionStatus
}) => {
  const isLaptop = useMediaQuery("laptop");
  return isLaptop ? (
    <PaidUserLandingLaptop
      primaryUser={primaryUser}
      userSubscriptionStatus={userSubscriptionStatus}
    />
  ) : (
    <PaidUserMobile primaryUser={primaryUser} />
  );
};

export { PaidUserLanding };
